export default __webpack_public_path__ + "static/media/upload-bg.6b21b57b.svg";